import { memo, ReactNode } from 'react';
import { TopNav } from './TopNav';
import { BottomNav } from './BottomNav';

interface NavigationProps {
	hideLogo?: boolean;
	hideSecondaryItems?: boolean;
	featuredAuthor?: boolean;
	authorDisplayName?: string;
	closeQuizToProfileOnTouchDevice?: boolean;
	bareTopNav?: boolean;
	topNavCenter?: ReactNode;
}

// Redesign shell: one responsive top bar (frosted, fixed) plus the mobile
// bottom bar with its sheets. The desktop/mobile split is CSS-driven at
// 1080px, matching useWindowListener's touchDevice boundary.
const NavigationComponent = ({
	hideLogo,
	hideSecondaryItems,
	featuredAuthor,
	authorDisplayName,
	closeQuizToProfileOnTouchDevice,
	bareTopNav,
	topNavCenter,
}: NavigationProps) => (
	<>
		<TopNav
			hideLogo={hideLogo}
			hideSecondaryItems={hideSecondaryItems}
			featuredAuthor={featuredAuthor}
			authorDisplayName={authorDisplayName}
			closeQuizToProfile={closeQuizToProfileOnTouchDevice}
			bare={bareTopNav}
			centerContent={topNavCenter}
		/>
		<BottomNav />
	</>
);

export const Navigation = memo(NavigationComponent);
